import { render, staticRenderFns } from "./FieldValue.vue?vue&type=template&id=118b2483"
import script from "./FieldValue.vue?vue&type=script&lang=js"
export * from "./FieldValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports